import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatNumberPipe } from './formatNumberForKm.pipe';

@NgModule({
  declarations: [FormatNumberPipe],
  imports: [CommonModule],
  exports: [FormatNumberPipe]
})
export class FormartNumberForKmModule { }
